"use strict";

module.exports = function(angular, moduleName) {
  angular
    .module(moduleName)
    .directive(
      "rtGlobalSettings",
      require("app/ui/directives/rtGlobalSettings/rtGlobalSettings")
    )
    .directive("rtInputDropdown", require("app/ui/directives/rtInputDropdown"))
    .directive(
      "rtOptionsProvider",
      require("app/ui/directives/rtOptionsProvider")
    )
    .directive(
      "rtSymbologyOptionsProvider",
      require("app/ui/directives/rtGlobalSettings/rtSymbologyOptionsProvider")
    )
    .factory("scrollParent", require("app/ui/utils/scrollParent"));
};



// WEBPACK FOOTER //
// ./app/ui/index.js